export const PLATFORM_SOURCE_WEB = 'web';
export const PLATFORM_FAMILY_WEB = 'web';
export const SIGNUP_SOURCE_FIELD = 'signupSource';

const isNonEmptyString = value => typeof value === 'string' && value.trim().length > 0;

export const getMixpanelPlatformProperties = () => ({
  platform: 'web',
  platform_source: PLATFORM_SOURCE_WEB,
  platform_family: PLATFORM_FAMILY_WEB,
  environment: process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development',
});

export const getSignupSourcePublicData = publicData => {
  const nextPublicData = publicData && typeof publicData === 'object' ? { ...publicData } : {};

  if (!isNonEmptyString(nextPublicData[SIGNUP_SOURCE_FIELD])) {
    nextPublicData[SIGNUP_SOURCE_FIELD] = PLATFORM_SOURCE_WEB;
  }

  return nextPublicData;
};
